export enum USER_PRIVILEGES {
    VIEW_VENDOR_CATEGORY = 'VIEW_VENDOR_CATEGORY',
    ADD_VENDOR_CATEGORY = 'ADD_VENDOR_CATEGORY',
    EDIT_VENDOR_CATEGORY = 'EDIT_VENDOR_CATEGORY',
    DELETE_VENDOR_CATEGORY = 'DELETE_VENDOR_CATEGORY',
    EXPORT_VENDOR_CATEGORIES = 'EXPORT_VENDOR_CATEGORIES',

    VIEW_VENDOR_DETAIL = 'VIEW_VENDOR_DETAIL',
    ADD_VENDOR_DETAIL = 'ADD_VENDOR_DETAIL',
    EDIT_VENDOR_DETAIL = 'EDIT_VENDOR_DETAIL',
    DELETE_VENDOR_DETAIL = 'DELETE_VENDOR_DETAIL',
    EXPORT_VENDOR_DETAILS = 'EXPORT_VENDOR_DETAILS',

    VIEW_VENDOR_LOCATION_MAPPING = 'VIEW_VENDOR_LOCATION_MAPPING',
    ADD_VENDOR_LOCATION_MAPPING = 'ADD_VENDOR_LOCATION_MAPPING',
    EDIT_VENDOR_LOCATION_MAPPING = 'EDIT_VENDOR_LOCATION_MAPPING',
    DELETE_VENDOR_LOCATION_MAPPING = 'DELETE_VENDOR_LOCATION_MAPPING',
    EXPORT_VENDOR_LOCATION_MAPPINGS = 'EXPORT_VENDOR_LOCATION_MAPPINGS',

    VIEW_VENDOR_USER_LOCATION_MAPPING = 'VIEW_VENDOR_USER_LOCATION_MAPPING',
    ADD_VENDOR_USER_LOCATION_MAPPING = 'ADD_VENDOR_USER_LOCATION_MAPPING',
    EDIT_VENDOR_USER_LOCATION_MAPPING = 'EDIT_VENDOR_USER_LOCATION_MAPPING',
    DELETE_VENDOR_USER_LOCATION_MAPPING = 'DELETE_VENDOR_USER_LOCATION_MAPPING',
    EXPORT_VENDOR_USER_LOCATION_MAPPINGS = 'EXPORT_VENDOR_USER_LOCATION_MAPPINGS',



    VIEW_LAW = 'VIEW_LAW_CATEGORY',
    ADD_LAW = 'ADD_LAW_CATEGORY',
    EDIT_LAW = 'EDIT_LAW_CATEGORY',
    DELETE_LAW = 'DELETE_LAW_CATEGORY',
    EXPORT_LAW = 'EXPORT_LAW_CATEGORIES',
    VIEW_ACT = 'VIEW_ACTS',
    ADD_ACT = 'ADD_ACT',
    EDIT_ACT = 'EDIT_ACT',
    DELETE_ACT = 'DELETE_ACT',
    EXPORT_ACT = 'EXPORT_ACTS',
    VIEW_ACTIVITY = 'VIEW_ACTIVITIES',
    ADD_ACTIVITY = 'ADD_ACTIVITY',
    EDIT_ACTIVITY = 'EDIT_ACTIVITY',
    DELETE_ACTIVITY = 'DELETE_ACTIVITY',
    EXPORT_ACTIVITY = 'EXPORT_ACTIVITIES',
    VIEW_RULE = 'VIEW_RULES',
    ADD_RULE = 'ADD_RULE',
    EDIT_RULE = 'EDIT_RULE',
    DELETE_RULE = 'DELETE_RULE',
    EXPORT_RULE = 'EXPORT_RULES',
    VIEW_STATE = 'VIEW_STATES',
    ADD_STATE = 'ADD_STATE',
    EDIT_STATE = 'EDIT_STATE',
    DELETE_STATE = 'DELETE_STATE',
    EXPORT_STATE = 'EXPORT_STATES',
    VIEW_CITY = 'VIEW_CITIES',
    ADD_CITY = 'ADD_CITY',
    EDIT_CITY = 'EDIT_CITY',
    DELETE_CITY = 'DELETE_CITY',
    EXPORT_CITY = 'EXPORT_CITIES',
    VIEW_MAPPINGS = 'VIEW_MAPPINGS',
    ADD_MAPPING = 'ADD_MAPPING',
    EDIT_MAPPING = 'EDIT_MAPPING',
    DELETE_MAPPING = 'DELETE_MAPPING',
    EXPORT_MAPPING = 'EXPORT_MAPPING',
    VIEW_COMPANIES = 'VIEW_COMPANIES',
    VIEW_VENDORS = 'VIEW_VENDORS',
    ADD_COMPANY = 'ADD_COMPANY',
    EDIT_COMPANY = 'EDIT_COMPANY',
    DELETE_COMPANY = 'DELETE_COMPANY',
    EXPORT_COMPANIES = 'EXPORT_COMPANIES',
    VIEW_ASSOCIATE_COMPANIES = 'VIEW_ASSOCIATE_COMPANIES',
    ADD_ASSOCIATE_COMPANY = 'ADD_ASSOCIATE_COMPANY',
    EDIT_ASSOCIATE_COMPANY = 'EDIT_ASSOCIATE_COMPANY',
    DELETE_ASSOCIATE_COMPANY = 'DELETE_ASSOCIATE_COMPANY',
    EXPORT_ASSOCIATE_COMPANIES = 'EXPORT_ASSOCIATE_COMPANIES',
    VIEW_LOCATION_MAPPINGS = 'VIEW_LOCATION_MAPPINGS',
    ADD_LOCATION_MAPPING = 'ADD_LOCATION_MAPPING',
    EDIT_LOCATION_MAPPING = 'EDIT_LOCATION_MAPPING',
    DELETE_LOCATION_MAPPING = 'DELETE_LOCATION_MAPPING',
    EXPORT_LOCATION_MAPPINGS = 'EXPORT_LOCATION_MAPPINGS',
    VIEW_VERTICAL = 'VIEW_VERTICALS',
    ADD_VERTICAL = 'ADD_VERTICAL',
    EDIT_VERTICAL = 'EDIT_VERTICAL',
    DELETE_VERTICAL = 'DELETE_VERTICAL',
    EXPORT_VERTICAL = 'EXPORT_VERTICALS',
    VIEW_DEPARTMENT = 'VIEW_DEPARTMENTS',
    ADD_DEPARTMENT = 'ADD_DEPARTMENT',
    EDIT_DEPARTMENT = 'EDIT_DEPARTMENT',
    DELETE_DEPARTMENT = 'DELETE_DEPARTMENT',
    EXPORT_DEPARTMENT = 'EXPORT_DEPARTMENTS',
    VIEW_ROLES = 'VIEW_ROLES',
    ADD_ROLE = 'ADD_ROLE',
    EDIT_ROLE = 'EDIT_ROLE',
    DELETE_ROLE = 'DELETE_ROLE',
    VIEW_USERS = 'VIEW_USERS',
    ADD_USER = 'ADD_USER',
    EDIT_USER = 'EDIT_USER',
    DELETE_USER = 'DELETE_USER',
    EXPORT_USER = 'EXPORT_USERS',
    VIEW_COMPANY_MAPPINGS = 'VIEW_COMPANY_MAPPINGS',
    VIEW_VENDOR_MAPPINGS = 'VIEW_VENDOR_MAPPINGS',
    UPDATE_COMPANY_MAPPINGS = 'UPDATE_COMPANY_MAPPINGS',
    VIEW_DEPARTMENT_USER_MAPPING = 'VIEW_DEPARTMENT_USER_MAPPING',
    ADD_DEPARTMENT_USER_MAPPING = 'ADD_DEPARTMENT_USER_MAPPING',
    UPDATE_DEPARTMENT_USER_MAPPING = 'UPDATE_DEPARTMENT_USER_MAPPING',
    DELETE_DEPARTMENT_USER_MAPPING = 'DELETE_DEPARTMENT_USER_MAPPING',
    VIEW_COMPANY_ESCALTION_MATIX = 'VIEW_COMPANY_ESCALTION_MATIX',
    ADD_COMPANY_ESCALTION_MATIX = 'ADD_COMPANY_ESCALTION_MATIX',
    EDIT_COMPANY_ESCALTION_MATIX = 'EDIT_COMPANY_ESCALTION_MATIX',
    DELETE_COMPANY_ESCALTION_MATIX = 'DELETE_COMPANY_ESCALTION_MATIX',
    AUDIT_SCHEDULE = 'AUDIT_SCHEDULE',
    AUDIT_VENDOR_SCHEDULE = 'AUDIT_VENDOR_CHEDULE',
    VIEW_AUDIT_SCHEDULE_DETAILS = 'VIEW_AUDIT_SCHEDULE_DETAILS',
    VIEW_AUDIT_VENDOR_SCHEDULE_DETAILS = 'VIEW_AUDIT_VENDOR_SCHEDULE_DETAILS',
    DELETE_AUDIT_SCHEDULE_DETAILS = 'DELETE_AUDIT_SCHEDULE_DETAILS',
    DELETE_AUDIT_VENDOR_SCHEDULE_DETAILS = 'DELETE_AUDIT_VENDOR_SCHEDULE_DETAILS',
    VIEW_AUDIT_SCHEDULE_BLOCK_UNBLOCK = 'VIEW_AUDIT_SCHEDULE_BLOCK_UNBLOCK',
    VIEW_AUDIT_VENDOR_SCHEDULE_BLOCK_UNBLOCK = 'VIEW_AUDIT_VENDOR_SCHEDULE_BLOCK_UNBLOCK',
    AUDIT_SCHEDULE_UNBLOCK_BLOCKED = 'AUDIT_SCHEDULE_UNBLOCK_BLOCKED',
    AUDIT_SCHEDULE_VENDOR_UNBLOCK_BLOCKED = 'AUDIT_SCHEDULE_VENDOR_UNBLOCK_BLOCKED',
    COMPLIANCE_SCHEDULE = 'COMPLIANCE_SCHEDULE',
    VIEW_COMPLIANCE_SCHEDULE_DETAILS = 'VIEW_COMPLIANCE_SCHEDULE_DETAILS',
    ASSIGN_COMPLIANCE_SCHEDULE_DETAILS = 'ASSIGN_COMPLIANCE_SCHEDULE_DETAILS',
    DELETE_COMPLIANCE_SCHEDULE_DETAILS = 'DELETE_COMPLIANCE_SCHEDULE_DETAILS',
    VIEW_EMAIL_TEMPLATES = 'VIEW_EMAIL_TEMPLATES',
    ADD_EMAIL_TEMPLATE = 'ADD_EMAIL_TEMPLATE',
    EDIT_EMAIL_TEMPLATE = 'EDIT_EMAIL_TEMPLATE',
    DELETE_EMAIL_TEMPLATE = 'DELETE_EMAIL_TEMPLATE',
    VIEW_NOTIFICATION_TEMPLATES = 'VIEW_NOTIFICATION_TEMPLATES',
    ADD_NOTIFICATION_TEMPLATE = 'ADD_NOTIFICATION_TEMPLATE',
    EDIT_NOTIFICATION_TEMPLATE = 'EDIT_NOTIFICATION_TEMPLATE',
    DELETE_NOTIFICATION_TEMPLATE = 'DELETE_NOTIFICATION_TEMPLATE',
    VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS',
    RESEND_NOTIFICATION = 'RESEND_NOTIFICATION',
    SUBMITTER_DASHBOARD = 'SUBMITTER_DASHBOARD',
    VENDOR_AUDIT_DASHBOARD = 'VENDOR_AUDIT_DASHBOARD',
    LOCATION_AUDIT_DASHBOARD = 'LOCATION_AUDIT_DASHBOARD',
    REVIEWER_DASHBOARD = 'REVIEWER_DASHBOARD',
    OWNER_DASHBOARD = 'OWNER_DASHBOARD',
    MANAGER_DASHBOARD = 'MANAGER_DASHBOARD',
    ESCALATION_DASHBOARD = 'ESCALATION_DASHBOARD',

//START - OLD PRIVILGES
// REVIEWER
    REVIEWER_ACTIVITIES = 'REVIEWER_ACTIVITIES',
    REVIEWER_ACTIVITIES_AUDIT = 'REVIEWER_ACTIVITIES_AUDIT',
    REVIEWER_ACTIVITIES_PUBLISH = 'REVIEWER_ACTIVITIES_PUBLISH',
    REVIEWER_ACTIVITIES_DOWNLOAD_REPORT = 'REVIEWER_ACTIVITIES_DOWNLOAD_REPORT',


    // OWNER_ACTIVITIES = 'OWNER_ACTIVITIES',
    OWNER_ACTIVITIES_SUBMIT = 'OWNER_ACTIVITIES_SUBMIT',
    OWNER_ACTIVITIES_DOCUMENT_UPLOAD = 'OWNER_ACTIVITIES_DOCUMENT_UPLOAD',

    // MANAGER_ACTIVITIES = 'MANAGER_ACTIVITIES',
    MANAGER_ACTIVITIES_REVIEW = 'MANAGER_ACTIVITIES_REVIEW',

//SUBMITTER
    SUBMITTER_ACTIVITIES = 'SUBMITTER_ACTIVITIES',
    SUBMITTER_ACTIVITIES_SUBMIT = 'SUBMITTER_ACTIVITIES_SUBMIT',
    SUBMITTER_ACTIVITIES_UPLOAD = 'SUBMITTER_ACTIVITIES_UPLOAD',
    SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT = 'SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT',
//  END OF OLD PRIVILIGES

// ---------------------

    // START NEW PRIVILIGES
    REVIEWER_VENDOR_ACTIVITIES = 'REVIEWER_VENDOR_ACTIVITIES',
    REVIEWER_VENDOR_ACTIVITIES_AUDIT = 'REVIEWER_VENDOR_ACTIVITIES_AUDIT',
    REVIEWER_VENDOR_ACTIVITIES_PUBLISH = 'REVIEWER_VENDOR_ACTIVITIES_PUBLISH',
    REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT = 'REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT',
    REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT = 'REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT',

    // OWNER_ACTIVITIES = 'OWNER_ACTIVITIES',
    OWNER_VENDOR_ACTIVITIES_SUBMIT = 'OWNER_VENDOR_ACTIVITIES_SUBMIT',
    OWNER_VENDOR_ACTIVITIES_DOCUMENT_UPLOAD = 'OWNER_VENDOR_ACTIVITIES_DOCUMENT_UPLOAD',

     // MANAGER_ACTIVITIES = 'MANAGER_ACTIVITIES',
     MANAGER_VENDOR_ACTIVITIES_REVIEW = 'MANAGER_VENDOR_ACTIVITIES_REVIEW',

     //SUBMITTER
     SUBMITTER_VENDOR_ACTIVITIES = 'SUBMITTER_VENDOR_ACTIVITIES',
     SUBMITTER_VENDOR_ACTIVITIES_SUBMIT = 'SUBMITTER_VENDOR_ACTIVITIES_SUBMIT',
     SUBMITTER_VENDOR_ACTIVITIES_UPLOAD = 'SUBMITTER_VENDOR_ACTIVITIES_UPLOAD',
     SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT = 'SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT',
     SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT = 'SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT',

// END OF NEW PRIVILIGES 

    VIEW_USER_NOTIFICATIONS = 'VIEW_USER_NOTIFICATIONS',
    VIEW_NOTICES = 'VIEW_NOTICES',
    ADD_NOTICE = 'ADD_NOTICE',
    ASSIGN_NOTICE = 'ASSIGN_NOTICE',
    EDIT_NOTICE = 'EDIT_NOTICE',
    DELETE_NOTICE = 'DELETE_NOTICE',
    INPUT_DASHBOARD = 'INPUT_DASHBOARD',
    VIEW_HOLIDAY_LIST = 'VIEW_HOLIDAY_LIST',
    ADD_HOLIDAY_LIST = 'ADD_HOLIDAY_LIST',
    EDIT_HOLIDAY_LIST = 'EDIT_HOLIDAY_LIST',
    DELETE_HOLIDAY_LIST = 'DELETE_HOLIDAY_LIST',
    VIEW_LEAVE_CONFIGURATION = 'VIEW_LEAVE_CONFIGURATION',
    ADD_LEAVE_CONFIGURATION = 'ADD_LEAVE_CONFIGURATION',
    EDIT_LEAVE_CONFIGURATION = 'EDIT_LEAVE_CONFIGURATION',
    DELETE_LEAVE_CONFIGURATION = 'DELETE_LEAVE_CONFIGURATION',
    VIEW_ATTENDANCE_CONFIGURATION = 'VIEW_ATTENDANCE_CONFIGURATION',
    ADD_ATTENDANCE_CONFIGURATION = 'ADD_ATTENDANCE_CONFIGURATION',
    EDIT_ATTENDANCE_CONFIGURATION = 'EDIT_ATTENDANCE_CONFIGURATION',
    DELETE_ATTENDANCE_CONFIGURATION = 'DELETE_ATTENDANCE_CONFIGURATION',
    VIEW_SALARY_COMPONENTS = 'VIEW_SALARY_COMPONENTS',
    ADD_SALARY_COMPONENTS = 'ADD_SALARY_COMPONENTS',
    VIEW_INPUT_MODULE_UPLOAD = 'VIEW_INPUT_MODULE_UPLOAD',
    ADD_INPUT_MODULE_UPLOAD = 'ADD_INPUT_MODULE_UPLOAD',
    VIEW_EMPLOYEE_DASHBOARD = 'VIEW_EMPLOYEE_DASHBOARD',
    REGISTER_GENERATION_DASHBOARD = 'REGISTER_EMPLOYEE_DASHBOARD',
    REGISTER_GENERATION_QUE = 'REGISTER_EMPLOYEE_QUE',
    VIEW_EMPLOYEE_MASTER = 'VIEW_EMPLOYEE_MASTER',
    DELETE_EMPLOYEE_MASTER = 'DELETE_EMPLOYEE_MASTER',
    VIEW_EMPLOYEE_LEAVE_CREDIT = 'VIEW_EMPLOYEE_LEAVE_CREDIT',
    DELETE_EMPLOYEE_LEAVE_CREDIT = 'DELETE_EMPLOYEE_LEAVE_CREDIT',
    VIEW_EMPLOYEE_LEAVE_AVAILED = 'VIEW_EMPLOYEE_LEAVE_AVAILED',
    DELETE_EMPLOYEE_LEAVE_AVAILED = 'DELETE_EMPLOYEE_LEAVE_AVAILED',
    VIEW_EMPLOYEE_ATTENDANCE = 'VIEW_EMPLOYEE_ATTENDANCE',
    DELETE_EMPLOYEE_ATTENDANCE = 'DELETE_EMPLOYEE_ATTENDANCE',
    VIEW_EMPLOYEE_WAGE = 'VIEW_EMPLOYEE_WAGE',
    DELETE_EMPLOYEE_WAGE = 'DELETE_EMPLOYEE_WAGE',
    VIEW_STATEREGISTER_CONFIGURATION = 'VIEW_STATEREGISTER_CONFIGURATION',
    VIEW_REGISTER_DOWNLOAD = 'VIEW_REGISTER_DOWNLOAD',
    VIEW_REGISTER_QUE = 'VIEW_REGISTER_QUE',

    // License Types
    VIEW_LICENSE_TYPES = 'VIEW_LICENSE_TYPES',
    ADD_LICENSE_TYPE = 'ADD_LICENSE_TYPE',
    EDIT_LICENSE_TYPE = 'EDIT_LICENSE_TYPE',

    // License Applications
    VIEW_LICENSE_APPLICATIONS = 'VIEW_LICENSE_APPLICATIONS',
    CREATE_AND_EDIT_LICENSE_APPLICATION = 'CREATE_AND_EDIT_LICENSE_APPLICATION',

    // Company Licenses
    VIEW_LICENSE_DASHBOARD = 'VIEW_LICENSE_DASHBOARD',
    CREATE_COMPANY_LICENSE = 'CREATE_COMPANY_LICENSE',
    EDIT_COMPANY_LICENSE = 'EDIT_COMPANY_LICENSE',
}

export const PAGES_CONFIGURATION = [
    {
        id: "SETUP_INPUT",
        name: "Setup input",
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_HOLIDAY_LIST,
                name: 'View Holiday List'
            },
            {
                id: USER_PRIVILEGES.ADD_HOLIDAY_LIST,
                name: 'Add Holiday List'
            },
            {
                id: USER_PRIVILEGES.EDIT_HOLIDAY_LIST,
                name: 'Edit Holiday List'
            },
            {
                id: USER_PRIVILEGES.DELETE_HOLIDAY_LIST,
                name: 'Delete Holiday List'
            },
                {
                    id: USER_PRIVILEGES.VIEW_LEAVE_CONFIGURATION,
                    name: 'View Leave Configuration'
                },
                {
                    id: USER_PRIVILEGES.ADD_LEAVE_CONFIGURATION,
                    name: 'Add Leave Configuration'
                },
                {
                    id: USER_PRIVILEGES.EDIT_LEAVE_CONFIGURATION,
                    name: 'Edit Leave Configuration'
                },
                {
                    id: USER_PRIVILEGES.DELETE_LEAVE_CONFIGURATION,
                    name: 'Delete Leave Configuration'
                },
                {
                    id: USER_PRIVILEGES.VIEW_ATTENDANCE_CONFIGURATION,
                    name: 'View Attendance Configuration'
                },
                {
                    id: USER_PRIVILEGES.ADD_ATTENDANCE_CONFIGURATION,
                    name: 'Add Attendance Configuration'
                },
                {
                    id: USER_PRIVILEGES.EDIT_ATTENDANCE_CONFIGURATION,
                    name: 'Edit Attendance Configuration'
                },
                {
                    id: USER_PRIVILEGES.DELETE_ATTENDANCE_CONFIGURATION,
                    name: 'Delete Attendance Configuration'
                },
                {
                    id: USER_PRIVILEGES.VIEW_SALARY_COMPONENTS,
                    name: 'View Salary Components'
                },
                {
                    id: USER_PRIVILEGES.ADD_SALARY_COMPONENTS,
                    name: 'Add Salary Components'
                },
                {
                    id: USER_PRIVILEGES.VIEW_INPUT_MODULE_UPLOAD,
                    name: 'View Input Module Upload'
                },
                {
                    id: USER_PRIVILEGES.ADD_INPUT_MODULE_UPLOAD,
                    name: 'Add Input Module Upload'
                }
        ]
    },
    {
        id: "INPUT_UPLOAD",
        name: "Input upload",
        isMulti: true,
        privileges: [
        
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_DASHBOARD,
                name: 'View Employee Dashboard'
            },
            {
                id: USER_PRIVILEGES.REGISTER_GENERATION_DASHBOARD,
                name: 'Register Generation DashBoard'
            },
            {
                id: USER_PRIVILEGES.REGISTER_GENERATION_QUE,
                name: 'Register Generation Que'
            },
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_MASTER,
                name: 'View Employee Master'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMPLOYEE_MASTER,
                name: 'Delete Employee Master'
            },
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_CREDIT,
                name: 'View Employee Leave Credit'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMPLOYEE_LEAVE_CREDIT,
                name: 'Delete Employee Leave Credit'
            },
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_AVAILED,
                name: 'View Employee Leave Availed'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMPLOYEE_LEAVE_AVAILED,
                name: 'Delete Employee Leave Availed'
            },
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_ATTENDANCE,
                name: 'View Employee Attendance'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMPLOYEE_ATTENDANCE,
                name: 'Delete Employee Attendance'
            },
            {
                id: USER_PRIVILEGES.VIEW_EMPLOYEE_WAGE,
                name: 'View Employee WAGE'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMPLOYEE_WAGE,
                name: 'Delete Employee WAGE'
            },
            {
                id: USER_PRIVILEGES.VIEW_REGISTER_DOWNLOAD,
                name: 'View Register Download'
            },
            {
                id: USER_PRIVILEGES.VIEW_REGISTER_QUE,
                name: 'View Register Que'
            },
    ]
    },
    {
        id: 'MASTER',
        name: 'Masters',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_VENDOR_CATEGORY,
                name: 'View Vendor Categories'
            },
            {
                id: USER_PRIVILEGES.ADD_VENDOR_CATEGORY,
                name: 'Add Vendor Category'
            },
            {
                id: USER_PRIVILEGES.EDIT_VENDOR_CATEGORY,
                name: 'Edit Vendor Category'
            },
            {
                id: USER_PRIVILEGES.DELETE_VENDOR_CATEGORY,
                name: 'Delete Vendor Category'
            },
            {
                id: USER_PRIVILEGES.EXPORT_VENDOR_CATEGORIES,
                name: 'Export Vendor Category'
            },
            {
                id: USER_PRIVILEGES.VIEW_LAW,
                name: 'View Law Categories'
            },
            {
                id: USER_PRIVILEGES.ADD_LAW,   
                name: 'Add Law Category'
            },
            {
                id: 'EDIT_LAW',
                name: 'Edit Law Category'
            },
            {
                id: USER_PRIVILEGES.DELETE_LAW,
                name: 'Delete Law Category'
            },
            {
                id: USER_PRIVILEGES.EXPORT_LAW,
                name: 'Export Law Category'
            },
            {
                id: USER_PRIVILEGES.VIEW_ACT,
                name: 'View Acts'
            },
            {
                id: USER_PRIVILEGES.ADD_ACT,
                name: 'Add Act'
            },
            {
                id: USER_PRIVILEGES.EDIT_ACT,
                name: 'Edit Act'
            },
            {
                id: USER_PRIVILEGES.DELETE_ACT,
                name: 'Delete Act'
            },
            {
                id: USER_PRIVILEGES.EXPORT_ACT,
                name: 'Export Acts'
            },
            {
                id: USER_PRIVILEGES.VIEW_ACTIVITY,
                name: 'View Activities'
            },
            {
                id: USER_PRIVILEGES.ADD_ACTIVITY,
                name: 'Add Activity'
            },
            {
                id: USER_PRIVILEGES.EDIT_ACTIVITY,
                name: 'Edit Activity'
            },
            {
                id: USER_PRIVILEGES.DELETE_ACTIVITY,
                name: 'Delete Activity'
            },
            {
                id: USER_PRIVILEGES.EXPORT_ACTIVITY,
                name: 'Export Activities'
            },
            {
                id: USER_PRIVILEGES.VIEW_RULE,
                name: 'View Rules'
            },
            {
                id: USER_PRIVILEGES.ADD_RULE,
                name: 'Add Rule'
            },
            {
                id: USER_PRIVILEGES.EDIT_RULE,
                name: 'Edit Rule'
            },
            {
                id: USER_PRIVILEGES.DELETE_RULE,
                name: 'Delete Rule'
            },
            {
                id: USER_PRIVILEGES.EXPORT_RULE,
                name: 'Export Rules'
            },
            {
                id: USER_PRIVILEGES.VIEW_STATE,
                name: 'View States'
            },
            {
                id: USER_PRIVILEGES.ADD_STATE,
                name: 'Add State'
            },
            {
                id: USER_PRIVILEGES.EDIT_STATE,
                name: 'Edit State'
            },
            {
                id: USER_PRIVILEGES.DELETE_STATE,
                name: 'Delete State'
            },
            {
                id: USER_PRIVILEGES.EXPORT_STATE,
                name: 'Export States'
            },
            {
                id: USER_PRIVILEGES.VIEW_CITY,
                name: 'View Cities'
            },
            {
                id: USER_PRIVILEGES.ADD_CITY,
                name: 'Add City'
            },
            {
                id: USER_PRIVILEGES.EDIT_CITY,
                name: 'Edit City'
            },
            {
                id: USER_PRIVILEGES.DELETE_CITY,
                name: 'Delete City'
            },
            {
                id: USER_PRIVILEGES.EXPORT_CITY,
                name: 'Export Cities'
            },
            {
                id: USER_PRIVILEGES.VIEW_MAPPINGS,
                name: 'View Mappings'
            },
            {
                id: USER_PRIVILEGES.ADD_MAPPING,
                name: 'Add Mapping'
            },
            {
                id: USER_PRIVILEGES.EDIT_MAPPING,
                name: 'Edit Mapping'
            },
            {
                id: USER_PRIVILEGES.DELETE_MAPPING,
                name: 'Delete Mapping'
            },
            {
                id: USER_PRIVILEGES.EXPORT_MAPPING,
                name: 'Export Mappings'
            }
            ,
            {
                id: USER_PRIVILEGES.VIEW_STATEREGISTER_CONFIGURATION,
                name: 'View State Register Configuration'
            }
        ]
    },
    {
        id: 'COMPANIES',
        name: 'Companies',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_COMPANIES,
                name: 'View Companies'
            },
            {
                id: USER_PRIVILEGES.ADD_COMPANY,
                name: 'Add Company'
            },
            {
                id: USER_PRIVILEGES.EDIT_COMPANY,
                name: 'Edit Company'
            },
            {
                id: USER_PRIVILEGES.DELETE_COMPANY,
                name: 'Delete Company'
            },
            {
                id: USER_PRIVILEGES.EXPORT_COMPANIES,
                name: 'Export Companies'
            },
            {
                id: USER_PRIVILEGES.VIEW_ASSOCIATE_COMPANIES,
                name: 'View Associate Companies'
            },
            {
                id: USER_PRIVILEGES.ADD_ASSOCIATE_COMPANY,
                name: 'Add Associate Company'
            },
            {
                id: USER_PRIVILEGES.EDIT_ASSOCIATE_COMPANY,
                name: 'Edit Associate Company'
            },
            {
                id: USER_PRIVILEGES.DELETE_ASSOCIATE_COMPANY,
                name: 'Delete Associate Company'
            },
            {
                id: USER_PRIVILEGES.EXPORT_ASSOCIATE_COMPANIES,
                name: 'Export Associate Companies'
            },
            {
                id: USER_PRIVILEGES.VIEW_LOCATION_MAPPINGS,
                name: 'View Location Mappings'
            },
            {
                id: USER_PRIVILEGES.ADD_LOCATION_MAPPING,
                name: 'Add Location Mapping'
            },
            {
                id: USER_PRIVILEGES.EDIT_LOCATION_MAPPING,
                name: 'Edit Location Mapping'
            },
            {
                id: USER_PRIVILEGES.DELETE_LOCATION_MAPPING,
                name: 'Delete Location Mapping'
            },
            {
                id: USER_PRIVILEGES.EXPORT_LOCATION_MAPPINGS,
                name: 'Export Location Mappings'
            },
            {
                id: USER_PRIVILEGES.VIEW_VERTICAL,
                name: 'View Verticals'
            },
            {
                id: USER_PRIVILEGES.ADD_VERTICAL,
                name: 'Add Vertical'
            },
            {
                id: USER_PRIVILEGES.EDIT_VERTICAL,
                name: 'Edit Vertical'
            },
            {
                id: USER_PRIVILEGES.DELETE_VERTICAL,
                name: 'Delete Vertical'
            },
            {
                id: USER_PRIVILEGES.EXPORT_VERTICAL,
                name: 'Export Verticals'
            },
            {
                id: USER_PRIVILEGES.VIEW_DEPARTMENT,
                name: 'View Departments'
            },
            {
                id: USER_PRIVILEGES.ADD_DEPARTMENT,
                name: 'Add Department'
            },
            {
                id: USER_PRIVILEGES.EDIT_DEPARTMENT,
                name: 'Edit Department'
            },
            {
                id: USER_PRIVILEGES.DELETE_DEPARTMENT,
                name: 'Delete Department'
            },
            {
                id: USER_PRIVILEGES.EXPORT_DEPARTMENT,
                name: 'Export Departments'
            },
            {
                id: USER_PRIVILEGES.VIEW_COMPANY_ESCALTION_MATIX,
                name: 'View Escalation Matrix'
            },
            {
                id: USER_PRIVILEGES.ADD_COMPANY_ESCALTION_MATIX,
                name: 'Add Escalation Matrix'
            },
            {
                id: USER_PRIVILEGES.EDIT_COMPANY_ESCALTION_MATIX,
                name: 'Edit Escalation Matrix'
            },
            {
                id: USER_PRIVILEGES.DELETE_COMPANY_ESCALTION_MATIX,
                name: 'Delete Escalation Matrix'
            },
            {
                id: USER_PRIVILEGES.VIEW_VENDOR_LOCATION_MAPPING,
                name: 'View Vendor Location Mapping'
            },
            {
                id: USER_PRIVILEGES.ADD_VENDOR_LOCATION_MAPPING,
                name: 'Add Vendor Location Mapping'
            },
            {
                id: USER_PRIVILEGES.EDIT_VENDOR_LOCATION_MAPPING,
                name: 'Edit Vendor Location Mapping'
            },
            {
                id: USER_PRIVILEGES.DELETE_VENDOR_LOCATION_MAPPING,
                name: 'Delete Vendor Location Mapping'
            },
            {
                id: USER_PRIVILEGES.EXPORT_VENDOR_LOCATION_MAPPINGS,
                name: 'Export Vendor Location Mappings'
            },
            {
                id: USER_PRIVILEGES.VIEW_VENDORS,
                name: 'View Vendors'
            },
            {
                id: USER_PRIVILEGES.VIEW_VENDOR_DETAIL,
                name: 'View Vendor Detail'
            },
            {
                id: USER_PRIVILEGES.ADD_VENDOR_DETAIL,
                name: 'Add Vendor Detail'
            },
            {
                id: USER_PRIVILEGES.EDIT_VENDOR_DETAIL,
                name: 'Edit Vendor Detail'
            },
            {
                id: USER_PRIVILEGES.DELETE_VENDOR_DETAIL,
                name: 'Delete Vendor Detail'
            },
            {
                id: USER_PRIVILEGES.EXPORT_VENDOR_DETAILS,
                name: 'Export Vendor Details'
            },
        ]
    },
    {
        id: 'AUDIT_MANAGEMENT',
        name: 'Audit Management',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.AUDIT_SCHEDULE,
                name: 'Audit Schedule'
            },
            {
                id: USER_PRIVILEGES.VIEW_AUDIT_SCHEDULE_DETAILS,
                name: 'View Audit Schedule Details'
            },
            {
                id: USER_PRIVILEGES.DELETE_AUDIT_SCHEDULE_DETAILS,
                name: 'Delete Audit Schedule Details'
            },
            {
                id: USER_PRIVILEGES.VIEW_AUDIT_SCHEDULE_BLOCK_UNBLOCK,
                name: 'View Un-Block Activities'
            },
            {
                id: USER_PRIVILEGES.AUDIT_SCHEDULE_UNBLOCK_BLOCKED,
                name: 'Un-Block Blocked'
            }
        ]
    },
    {
        id: 'AUDIT_VENDOR_MANAGEMENT',
        name: 'Vendor Audit Management',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.AUDIT_VENDOR_SCHEDULE,
                name: 'Audit Schedule'
            },
            {
                id: USER_PRIVILEGES.VIEW_AUDIT_VENDOR_SCHEDULE_DETAILS,
                name: 'View Audit Schedule Details'
            },
            {
                id: USER_PRIVILEGES.DELETE_AUDIT_VENDOR_SCHEDULE_DETAILS,
                name: 'Delete Audit Schedule Details'
            },
            {
                id: USER_PRIVILEGES.VIEW_AUDIT_VENDOR_SCHEDULE_BLOCK_UNBLOCK,
                name: 'View Un-Block Activities'
            },
            {
                id: USER_PRIVILEGES.AUDIT_SCHEDULE_VENDOR_UNBLOCK_BLOCKED,
                name: 'Un-Block Blocked'
            }
        ]
    },
    {
        id: 'COMPLIANCE_MANAGEMENT',
        name: 'Compliance Management',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.COMPLIANCE_SCHEDULE,
                name: 'Compliance Schedule'
            },
            {
                id: USER_PRIVILEGES.VIEW_COMPLIANCE_SCHEDULE_DETAILS,
                name: 'View Compliance Schedule Details'
            },
            {
                id: USER_PRIVILEGES.ASSIGN_COMPLIANCE_SCHEDULE_DETAILS,
                name: 'Assign Compliance Schedule Details'
            },
            {
                id: USER_PRIVILEGES.DELETE_COMPLIANCE_SCHEDULE_DETAILS,
                name: 'Delete Compliance Schedule Details'
            }
        ]
    },
    {
        id: 'USER_MANAGEMENT',
        name: 'User Management',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_ROLES,
                name: 'View Roles'
            },
            {
                id: USER_PRIVILEGES.ADD_ROLE,
                name: 'Add Role'
            },
            {
                id: USER_PRIVILEGES.EDIT_ROLE,
                name: 'Edit Role'
            },
            {
                id: USER_PRIVILEGES.DELETE_ROLE,
                name: 'Delete Role'
            },
            {
                id: USER_PRIVILEGES.VIEW_USERS,
                name: 'View Users'
            },
            {
                id: USER_PRIVILEGES.ADD_USER,
                name: 'Add User'
            },
            {
                id: USER_PRIVILEGES.EDIT_USER,
                name: 'Edit User'
            },
            {
                id: USER_PRIVILEGES.DELETE_USER,
                name: 'Delete User'
            },
            {
                id: USER_PRIVILEGES.EXPORT_USER,
                name: 'Export Users'
            },
            {
                id: USER_PRIVILEGES.VIEW_COMPANY_MAPPINGS,
                name: 'View Company Mapping'
            },
            {
                id: USER_PRIVILEGES.VIEW_VENDOR_MAPPINGS,
                name: 'View Vendor User Mapping'
            },
            {
                id: USER_PRIVILEGES.UPDATE_COMPANY_MAPPINGS,
                name: 'Update Company Mapping'
            },
            {
                id: USER_PRIVILEGES.VIEW_DEPARTMENT_USER_MAPPING,
                name: 'View Department User Mapping'
            },
            {
                id: USER_PRIVILEGES.ADD_DEPARTMENT_USER_MAPPING,
                name: 'Add Department User Mapping'
            },
            {
                id: USER_PRIVILEGES.UPDATE_DEPARTMENT_USER_MAPPING,
                name: 'Update Department User Mapping'
            },
            {
                id: USER_PRIVILEGES.DELETE_DEPARTMENT_USER_MAPPING,
                name: 'Delete Department User Mapping'
            }
        ]
    },
    {
        id: 'EMAIL_NOTIFICATION',
        name: 'Emails & Notifications',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_EMAIL_TEMPLATES,
                name: 'View Email Templates'
            },
            {
                id: USER_PRIVILEGES.ADD_EMAIL_TEMPLATE,
                name: 'Add Email Template'
            },
            {
                id: USER_PRIVILEGES.EDIT_EMAIL_TEMPLATE,
                name: 'Edit Email Template'
            },
            {
                id: USER_PRIVILEGES.DELETE_EMAIL_TEMPLATE,
                name: 'Delete Email Template'
            },
            {
                id: USER_PRIVILEGES.VIEW_NOTIFICATIONS,
                name: 'View Notifications'
            },
            {
                id: USER_PRIVILEGES.RESEND_NOTIFICATION,
                name: 'Resend Notification'
            },
            {
                id: USER_PRIVILEGES.VIEW_NOTIFICATION_TEMPLATES,
                name: 'View Notification Templates'
            },
            {
                id: USER_PRIVILEGES.ADD_NOTIFICATION_TEMPLATE,
                name: 'Add Notification Template'
            },
            {
                id: USER_PRIVILEGES.EDIT_NOTIFICATION_TEMPLATE,
                name: 'Edit Notification Template'
            },
            {
                id: USER_PRIVILEGES.DELETE_NOTIFICATION_TEMPLATE,
                name: 'Delete Notification Template'
            }
        ]
    },
    {
        id: 'DASHBOARD',
        name: 'Dashboard',
        isMulti: false,
        privileges: [
            {
                id: USER_PRIVILEGES.OWNER_DASHBOARD,
                name: 'Owner',
                actions: [
                    {
                        id: USER_PRIVILEGES.OWNER_ACTIVITIES_SUBMIT,
                        name: 'Submit for Approval'
                    },
                    {
                        id: USER_PRIVILEGES.OWNER_ACTIVITIES_DOCUMENT_UPLOAD,
                        name: 'Upload Documents'
                    }
                ]
            },
            {
                id: USER_PRIVILEGES.MANAGER_DASHBOARD,
                name: 'Manager',
                actions: [
                    {
                        id: USER_PRIVILEGES.MANAGER_ACTIVITIES_REVIEW,
                        name: 'Submit for Approval'
                    }
                ]
            },
            {
                id: USER_PRIVILEGES.ESCALATION_DASHBOARD,
                name: 'Escalation'
            },
            {
                id: USER_PRIVILEGES.SUBMITTER_DASHBOARD,
                name: 'Submitter',
            },
            {
                id: USER_PRIVILEGES.REVIEWER_DASHBOARD,
                name: 'Reviewer',
            }
        ]
    },
    {
        id: 'VENDOR_ACTIVITIES',
        name: 'Vendor Activities',
        isMulti: false,
        privileges: [
            {
                id: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES,
                name: 'Vendor Actvities Submitter vendo',
                actions: [
                    {
                        id: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_SUBMIT,
                        name: 'Submit for Approval vendor'
                    },
                    {
                        id: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_UPLOAD,
                        name: 'Upload Documents vendor'
                    },
                    {
                        id: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT,
                        name: 'Download Report vendor'
                    },
                    {
                        id: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT,
                        name: 'Download Bulk Report vendor'
                    }
                ]
            },
            {
                id: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES,
                name: 'Vendor Audit Reviewer',
                actions: [
                    {
                        id: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_AUDIT,
                        name: 'Approve/Reject vendor'
                    },
                    {
                        id: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_PUBLISH,
                        name: 'Publish Activities vendor'
                    },
                    {
                        id: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_REPORT,
                        name: 'Download Report vendor'
                    },
                    {
                        id: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_DOWNLOAD_BULK_REPORT,
                        name: 'Download Report Bulk vendor'
                    },
                    {
                        id: USER_PRIVILEGES.VENDOR_AUDIT_DASHBOARD,
                        name: 'Vendor Audit Dashboard'
                    }
                ]
            },
        ]
    },
    {
        id: 'LOCATION_ACTIVITIES',
        name: 'Location Activities',
        isMulti: false,
        privileges: [
            {
                id: USER_PRIVILEGES.SUBMITTER_ACTIVITIES,
                name: 'Submitter',
                actions: [
                    {
                        id: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_SUBMIT,
                        name: 'Submit for Approval'
                    },
                    {
                        id: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_UPLOAD,
                        name: 'Upload Documents'
                    },
                    {
                        id: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT,
                        name: 'Download Report'
                    },
                    {
                        id: USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD,  
                        name: 'Location Audit Dashboard'
                    }
                ]
            },
            {
                id: USER_PRIVILEGES.REVIEWER_ACTIVITIES,
                name: 'Reviewer',
                actions: [
                    {
                        id: USER_PRIVILEGES.REVIEWER_ACTIVITIES_AUDIT,
                        name: 'Approve/Reject'
                    },
                    {
                        id: USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH,
                        name: 'Publish Activities'
                    },
                    {
                        id: USER_PRIVILEGES.REVIEWER_ACTIVITIES_DOWNLOAD_REPORT,
                        name: 'Download Report'
                    },
                    {
                        id: USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD,
                        name: 'Location Audit Dashboard',
                    }
                ]
            }
        ]
    },
    {
        id: 'USER_NOTIFICATION',
        name: 'Notifications',
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_USER_NOTIFICATIONS,
                name: 'View Notices',
            }
        ]
    },
    {
        id: 'NOTICES',
        name: 'Notices',
        isMulti: true,
        privileges: [
            {
                id: USER_PRIVILEGES.VIEW_NOTICES,
                name: 'View Notices',
            },
            {
                id: USER_PRIVILEGES.ADD_NOTICE,
                name: 'Add Notices',
            },
            {
                id: USER_PRIVILEGES.EDIT_NOTICE,
                name: 'Edit Notices',
            },
            {
                id: USER_PRIVILEGES.DELETE_NOTICE,
                name: 'Delete Notices',
            },
            {
                id: USER_PRIVILEGES.ASSIGN_NOTICE,
                name: 'Assign Notices',
            }
        ]
    },
    {
        id: 'LICENSE_MANAGEMENT',
        name: 'License Management',
        isMulti: true,
        privileges: [
            { id: USER_PRIVILEGES.VIEW_LICENSE_TYPES, name: 'View License Types' },
            { id: USER_PRIVILEGES.ADD_LICENSE_TYPE, name: 'Add License Type' },
            { id: USER_PRIVILEGES.EDIT_LICENSE_TYPE, name: 'Edit License Type' },
            { id: USER_PRIVILEGES.CREATE_AND_EDIT_LICENSE_APPLICATION, name: 'Create and Edit License Application' },
            { id: USER_PRIVILEGES.VIEW_LICENSE_DASHBOARD, name: 'View License Dashboard' },
            { id: USER_PRIVILEGES.CREATE_COMPANY_LICENSE, name: 'Create Company License' },
            { id: USER_PRIVILEGES.EDIT_COMPANY_LICENSE, name: 'Edit Company License' },
            { id: USER_PRIVILEGES.VIEW_LICENSE_APPLICATIONS, name: 'View License Applications' },
            // { id: USER_PRIVILEGES.DELETE_LICENSE_TYPE, name: 'Delete License Type' },
            // { id: USER_PRIVILEGES.EDIT_LICENSE_APPLICATION, name: 'Edit License Application' },
            // { id: USER_PRIVILEGES.DELETE_LICENSE_APPLICATION, name: 'Delete License Application' },
            // { id: USER_PRIVILEGES.ASSIGN_LICENSE_APPLICATION, name: 'Assign License Application' },
            // { id: USER_PRIVILEGES.VIEW_COMPANY_LICENSES, name: 'View Company Licenses' },
            // { id: USER_PRIVILEGES.DELETE_COMPANY_LICENSE, name: 'Delete Company License' },
            // { id: USER_PRIVILEGES.RENEW_LICENSE, name: 'Renew License' },
            // { id: USER_PRIVILEGES.SURRENDER_LICENSE, name: 'Surrender License' },
            // { id: USER_PRIVILEGES.VIEW_LICENSE_DOCUMENTS, name: 'View License Documents' },
            // { id: USER_PRIVILEGES.UPLOAD_LICENSE_DOCUMENTS, name: 'Upload License Documents' },
            // { id: USER_PRIVILEGES.DELETE_LICENSE_DOCUMENTS, name: 'Delete License Documents' },
            // { id: USER_PRIVILEGES.ASSIGN_LICENSE_OWNER, name: 'Assign License Owner' },
            // { id: USER_PRIVILEGES.ASSIGN_LICENSE_WATCHER, name: 'Assign License Watcher' },
            // { id: USER_PRIVILEGES.ESCALATE_LICENSE, name: 'Escalate License' }
        ]
    }

];
